// src/pages/AddModule.jsx
import React, { useState } from "react";
import { db } from "./firebase/firebaseConfig";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 40px;
  color: #fff;
  max-width: 500px;
  margin: auto;
`;

const Title = styled.h2`
  margin-bottom: 20px;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
  font-size: 16px;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: none;
  margin-bottom: 20px;
  font-size: 14px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #00d4ff, #00bcd4);
  color: #121212;
  font-weight: bold;
  cursor: pointer;
`;

const AddModule = () => {
  const { prepId } = useParams();
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);

  const handleAddModule = async () => {
    if (!title.trim()) {
      alert("Please enter module title");
      return;
    }

    setLoading(true);

    try {
      await addDoc(
        collection(db, `interviewPreps/${prepId}/modules`), // ✅ modules path
        {
          title,
          description,
          createdAt: serverTimestamp(),
        }
      );

      alert("✅ Module created successfully");

      navigate(`/interview-prep/${prepId}`); // back to list
    } catch (error) {
      console.error("Error adding module:", error);
      alert("❌ Failed to create module");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <Title>➕ Add Module</Title>

      <Input
        type="text"
        placeholder="Enter module title (e.g. React Hooks)"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <TextArea
        rows={4}
        placeholder="Optional description..."
        value={description}
        onChange={(e) => setDescription(e.target.value)}
      />

      <Button onClick={handleAddModule} disabled={loading}>
        {loading ? "Creating..." : "Create Module"}
      </Button>
    </Wrapper>
  );
};

export default AddModule;
